import { useState, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import LoadingSpinner from './LoadingSpinner';
import PremiumPaywall from './PremiumPaywall';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ user, children }) => {
  const { user: authUser, loading } = useAuth();
  const currentUser = user ?? authUser;
  if (loading && !currentUser) return <LoadingSpinner />;
  if (!currentUser) return <Navigate to="/login" replace />;
  return children;
};

export const PremiumRoute = ({ user, isPremium, checking, children, feature, description }) => {
  const { user: authUser, loading } = useAuth();
  const currentUser = user ?? authUser;
  if (loading && !currentUser) return <LoadingSpinner />;
  if (!currentUser) return <Navigate to="/login" replace />;
  if (checking) return <LoadingSpinner />;
  if (!isPremium) return <PremiumPaywall feature={feature} description={description} />;
  return children;
};

export function AdminGate({ user, children }) {
  const { user: authUser, loading } = useAuth();
  const currentUser = user ?? authUser;
  const [allowed, setAllowed] = useState(false);
  const [checking, setChecking] = useState(true);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    (async () => {
      try {
        if (!currentUser) { setAllowed(false); return; }
        const token = await currentUser.getIdTokenResult();
        let ok = Boolean(token.claims?.admin);
        if (!ok) {
          try {
            const bootstrap = httpsCallable(functions, 'bootstrapAdminClaim');
            await bootstrap();
            const refreshed = await currentUser.getIdTokenResult(true);
            ok = Boolean(refreshed.claims?.admin);
          } catch (err) {
            // user isn't eligible to bootstrap
          }
        }
        if (mountedRef.current) setAllowed(ok);
      } finally {
        if (mountedRef.current) setChecking(false);
      }
    })();
    return () => { mountedRef.current = false; };
  }, [currentUser]);
  if ((loading && !currentUser) || checking) return <LoadingSpinner />;
  return allowed ? children : <Navigate to="/" />;
}
